// extracted by mini-css-extract-plugin
export var dropdown = "_rs-0";
export var imageWrapper = "_rs-3";
export var itemNameContainer = "_rs-1";
export var productImage = "_rs-2";
export var spinnerWrapper = "_rs-4";